module.exports = __webpack_public_path__ + "images/icons/icon-home-b8a983bf.svg";